import React from 'react';
import PapelPicadoSvg from './PapelPicadoSvg';
import './MesPatrioDress.css';

function dropClass(grito, animate) {
  if (!animate) return '';
  return grito ? 'patrio-picado--grito' : 'patrio-picado--drop';
}

export function SarapeHairline({ axis = 'top' }) {
  return <div className={`patrio-sarape patrio-sarape--${axis}`} aria-hidden="true" />;
}

export function PapelPicadoFringe({ variant = 'topbar', grito = false, animate = true }) {
  return (
    <div className={`patrio-picado patrio-picado--${variant} ${dropClass(grito, animate)}`} aria-hidden="true">
      <PapelPicadoSvg />
    </div>
  );
}

export function MesPatrioLoginDress({ grito = false }) {
  return (
    <>
      <SarapeHairline axis="top" />
      <PapelPicadoFringe variant="login" grito={grito} />
      <SarapeHairline axis="bottom" />
    </>
  );
}

export function MesPatrioSidebarDress() {
  return <SarapeHairline axis="sidebar" />;
}

export function MesPatrioTopBarDress({ grito = false }) {
  return (
    <>
      <SarapeHairline axis="top" />
      <PapelPicadoFringe variant="topbar" grito={grito} />
    </>
  );
}

export function MesPatrioHangSlot() {
  return <div className="patrio-hang-slot" aria-hidden="true" />;
}

export function MesPatrioToggle({ enabled, onChange }) {
  return (
    <div className="patrio-toggle">
      <div className="patrio-toggle__copy">
        <h4>Mes patrio</h4>
        <p>Del 1 al 16 de septiembre. El 15 abre con fuegos y ¡Viva México!! Vista previa: <code>?patrio=15</code>. El 17 vuelve a la normalidad.</p>
      </div>
      <button
        type="button"
        className="patrio-switch"
        role="switch"
        aria-checked={enabled}
        aria-label="Activar vestido de mes patrio"
        title={enabled ? 'Quitar mes patrio' : 'Vestir mes patrio'}
        onClick={() => onChange(!enabled)}
      >
        <span />
      </button>
    </div>
  );
}
